export const INTERNAL_USER_REGEX = /.*@certificatehero.com$/;

/**
 * Checks if the user is an internal certificate hero user
 * @param {User} user
 * @returns {boolean}
 */
export const isInternalUser = user => INTERNAL_USER_REGEX.test(user.email);
